import axios from "axios";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

const APP_VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000;

export const useAppStore = defineStore("app", () => {
  const appVersion = ref("");
  const latestAppVersion = ref("");
  const initialAppVersion = ref("");

  let versionPollingTimer: number | undefined;

  const isUpdateAvailable = computed(
    () =>
      !!initialAppVersion.value &&
      !!latestAppVersion.value &&
      latestAppVersion.value !== initialAppVersion.value,
  );

  async function pollAppVersion(): Promise<void> {
    try {
      const response = await axios.get<string>(
        `/appversion?_=${Date.now()}`,
      );
      const version = String(response.data ?? "").trim();
      if (!version) {
        return;
      }

      latestAppVersion.value = version;

      if (!initialAppVersion.value) {
        initialAppVersion.value = version;
        appVersion.value = version;
      }
    } catch {
      // Ignore transient version polling failures.
    }
  }

  function initializeVersionPolling(): void {
    if (versionPollingTimer !== undefined) {
      return;
    }

    void pollAppVersion();
    versionPollingTimer = window.setInterval(
      () => void pollAppVersion(),
      APP_VERSION_POLL_INTERVAL_MS,
    );
  }

  function cleanupVersionPolling(): void {
    if (versionPollingTimer === undefined) {
      return;
    }

    window.clearInterval(versionPollingTimer);
    versionPollingTimer = undefined;
  }

  return {
    appVersion,
    latestAppVersion,
    isUpdateAvailable,
    initializeVersionPolling,
    cleanupVersionPolling,
  };
});
